function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.16602 13.4023C1.16602 16.2303 1.16602 17.6453 2.04502 18.5233C2.92302 19.4023 4.33802 19.4023 7.16602 19.4023H13.166C15.994 19.4023 17.409 19.4023 18.287 18.5233C19.166 17.6453 19.166 16.2303 19.166 13.4023M10.166 1.40234V14.4023M10.166 14.4023L14.166 10.0273M10.166 14.4023L6.16602 10.0273",
    stroke: "#277154",
    style: {
      stroke: "#277154",
      stroke: "color(display-p3 0.1529 0.4431 0.3294)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.31c7715d5a84668eab65836aaf40a9c7.svg";
export { ForwardRef as ReactComponent };